import '../styles/somewhere.css'

export function SomewhereElse() {
    return <div className='somewhere-page'>
        <h1 className='somewhere-header'>somewhere else...</h1>
    </div>
}